import VisualizeObjectives from '../components/course/visualize-objectives';
<template><VisualizeObjectives @model={{@model}} /></template>
